import { trackButtonEvent } from 'lib/analytics';
import ProductData from 'lib/product-data';

export const WAITLIST_LOCAL_STORAGE_KEY = 'vsOutOfStockWaitlistSubmitted';

export interface ActionObject {
  label: string;
  url?: string;
  onClick?: () => void;
  id?: string;
  disabled?: boolean;
}

export const createAddToCartAction = (
  productSku: string,
  // openCartFromUrl from CartContext — passed in because this module is not a
  // hook and cannot read the cart context itself.
  openCartFromUrl: (url: string) => void,
): ActionObject => ({
  label: 'Add to Cart',
  onClick: () => {
    trackButtonEvent('Add to Cart', window.location.pathname, {
      product_sku: productSku,
    });
    openCartFromUrl(
      ProductData[productSku]?.buyUrl ||
        `/cart?cart=${encodeURIComponent(productSku)}`,
    );
  },
});

export const createViewDetailsAction = (
  productSku: string,
  router?: any,
  options?: { setIsLoading?: (loading: boolean) => void; isLoading?: boolean },
): ActionObject => ({
  label: 'Learn More',
  url: ProductData[productSku]?.pdpUrl,
  onClick: router
    ? () => {
        if (options?.isLoading) return;
        if (options?.setIsLoading) options.setIsLoading(true);
        const pdpUrl = ProductData[productSku]?.pdpUrl;
        if (pdpUrl) {
          router.push(pdpUrl);
        } else if (options?.setIsLoading) {
          options.setIsLoading(false);
        }
      }
    : undefined,
});

export const createCustomAction = (
  label: string,
  url?: string,
  onClick?: () => void,
): ActionObject => ({
  label,
  url,
  onClick,
});
